import { useEffect, useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({ DetailwarehouseData }) => {

    console.log(DetailwarehouseData, "DetailwarehouseData");
    const [warehouseid,setWarehouseId] = useState('')
    useEffect(()=>{
        if (DetailwarehouseData) {
            setWarehouseId(DetailwarehouseData.name)
        }
    },[DetailwarehouseData])

        console.log(warehouseid,"warehouseid");
        
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];

    return (
        <>
            <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>
                {/* check box */}
                {/* <div style={{ marginBottom: '12px', display: 'flex', gap: '150px', padding: '0 12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: '400px', marginBottom: '18px' }}>
                        <input
                            type="checkbox"
                            checked={!!DetailwarehouseData?.is_group}
                            className="form-check-input me-2"
                            style={{
                                width: '15px',
                                height: '15px',
                                backgroundColor: !!DetailwarehouseData?.is_group ? '#270B79' : 'white',
                                borderColor: '#270B79',
                            }}
                        />


                        Is Group Warehouse
                    </label>

                </div> */}

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="Warehouse Name"
                                label="Warehouse Name"
                                style={{ height: "30px" }}
                                readOnly={true}
                                value={DetailwarehouseData?.warehouse_name || ''}
                            />
                        </div>
                    </div>
                    {/* <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Parent Warehouse "
                                label="Parent Warehouse"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.parent_warehouse || ''} />
                        </div>
                    </div> */}
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Company "
                                label="Company "
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.company || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Account"
                                label="Account"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.account || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Abbr"
                                label="Abbr"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.custom_abbr || ''}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
                <div className="col-12">
                    <p className="boxLabel m-0">Warehouse Contact Info</p>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Phone No."
                                label="Phone No."
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.phone_no || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Mobile No."
                                label="Mobile No."
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.mobile_no || ''}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Address Line 1"
                                label="Address Line 1"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.address_line_1 || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Address Line 2"
                                label="Address Line 2"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.address_line_2 || ''}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="County"
                                label="County"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.custom_country || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="State/Province"
                                label="State/Province"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.state || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="City/Town"
                                label="City/Town"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.city || ''}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                readOnly={true}
                                id="Postal Code"
                                label="Postal Code"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.pin || ''}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <ActivityCard doctype="Warehouse" docname={warehouseid} />
            </div>
        </>
    );
};

export default Tab1;